// WARNING: DO NOT EDIT.  This file is automatically generated
// Written by aws-amplify-serverless-plugin/1.4.2 on 2021-04-12T06:32:48.356Z

const awsmobile = {
    aws_cloud_logic_custom: [
        {
            endpoint: 'https://y1ny3lz1yd.execute-api.us-east-1.amazonaws.com/staging',
            name: 'ApiGatewayRestApi',
            region: 'us-east-1'
        }
    ],
    aws_cognito_identity_pool_id: 'us-east-1:ada23132-a186-4afd-89a1-a09001353bf1',
    aws_cognito_region: 'us-east-1',
    aws_project_region: 'us-east-1',
    aws_user_pools_id: 'us-east-1_SfYNLBDnr',
    aws_user_pools_web_client_id: 'b3ogi77cukovc3mae2qtk9gof'
};

export default awsmobile;
